// extracted by mini-css-extract-plugin
export default {"root":"mantinePill_root__K96A7","label":"mantinePill_label__qRqKv"};